import { Outlet } from "react-router-dom";
import AuthHome from "./AuthHome";

const AuthRoutes = () => {
    return (
        <AuthHome>
            <Outlet />
        </AuthHome>
    );
};

export default AuthRoutes;
